import React from 'react'
import { Flex, Icon, Heading, Text, Button } from '@afterpaytouch/core'
import { CheckoutPage } from '../../model'
import { useTranslation } from '../../utils/convergence'
import styles from './styles.module.css'
import { useCheckoutSizes } from '../../utils/responsive'
import { TrackPageViewed } from '../../integrations/monitoring'

export const PurchaseSuccessPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const { headingSize, textSize } = useCheckoutSizes()

  const handleOpenApp = () => {
    try {
      const url = t('common:openMobileAppUrl')
      window.open(url, '_blank', 'noopener')
    } catch (error) {
      console.error('Failed to open app:', error)
    }
  }

  return (
    <>
      <Flex direction='column'>
        <Flex alignItems='center' justifyContent='center' className={styles.iconWrapper}>
          <Icon name='Check' size='Medium' color='White' />
        </Flex>
        <Heading size={headingSize} className={styles.heading}>
          {t('purchaseSuccess:heading')}
        </Heading>
        <Text size={textSize} color='Gray50' className={styles.subtitle}>
          {t('purchaseSuccess:subtitle')}
        </Text>
        <Text size={textSize} color='Gray50' className={styles.description}>
          {t('purchaseSuccess:description')}
        </Text>
        <Button kind='Secondary' padding='Fluid' onClick={handleOpenApp}>
          {t('purchaseSuccess:openAppButton')}
        </Button>
      </Flex>
      <TrackPageViewed />
    </>
  )
}
